import { render, staticRenderFns } from "./inflation-scenario-step.vue?vue&type=template&id=a8baff96&scoped=true"
import script from "./inflation-scenario-step.vue?vue&type=script&lang=ts"
export * from "./inflation-scenario-step.vue?vue&type=script&lang=ts"
import style0 from "./inflation-scenario-step.vue?vue&type=style&index=0&id=a8baff96&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8baff96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8baff96')) {
      api.createRecord('a8baff96', component.options)
    } else {
      api.reload('a8baff96', component.options)
    }
    module.hot.accept("./inflation-scenario-step.vue?vue&type=template&id=a8baff96&scoped=true", function () {
      api.rerender('a8baff96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setup/scenario/steps/inflation-scenario-step.vue"
export default component.exports